import { sm2 } from 'sm-crypto'
import { sha1 } from './sha1'

// SM2 加密配置
const SM2_PUBLIC_KEY = '04299a92cfb205e86532e2f68546e8b5bad6f3e893f294326f9688c4f398fad48d0aa9cf352ec652b9f60096cdbb4a2361468937ec68f91e3205fcb64f4b9979ae' // 这里需要替换为实际的 SM2 公钥

/**
 * 密码加密处理
 * @param {string} password - 原始密码
 * @returns {string} - 加密后的密码
 */
export const encryptPassword = (password) => {
  // 先进行 SHA1 加密
  const sha1Password = sha1(password)
  console.log("sha1Password==",password,sha1Password);
  // 再进行 SM2 加密，使用默认的字符串格式输出
  const encryptedPassword = sm2.doEncrypt(sha1Password, SM2_PUBLIC_KEY)
  
  return encryptedPassword
}